<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<div class="flex classS pt-5 bg-blue-200 text-grey-darker text-4xl text-center p-4">
  <p class="imageClass"><img src="../assets/logo-wo-words.png"></p>
  {{ 'NationalTestingCenter' | translate }}
  <div class="text-2xl"><label>{{ username }}</label></div>
  <div>
    <div (click)="logOut()" class="flex p-3 text-white bg-red-500 rounded cursor-pointer text-center text-sm">
      <button class="rounded w-28 inline-flex items-center">
        <svg class="w-4 h-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd"
                d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0
                 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd"/>
        </svg>
        <span class="font-semibold"> {{ 'exit' | translate }} </span>
      </button>
    </div>
  </div>
</div>
<main class="flex w-full">
  <aside class="w-80 bg-blue-200 shadow-md hidden sm:block">
    <div class="flex flex-col justify-between p-4">
      <div class="text-sm">

        <div class="panel-menu">

          <div *ngIf="role !== 'operator'" class="panel-menu-section bg-blue-300">
            <div class="panel-menu-header cursor-pointer" (click)="toggleSection('administration')">
              <span>Администрирование</span>
              <span class="arrow" [ngClass]="{'rotated': isSectionOpen('administration')}">&#9660;</span></div>
            <div class="panel-menu-content" *ngIf="isSectionOpen('administration')">
              <a class="w-full p-1" [routerLink]="'/main/add-user'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/add-user')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  {{ 'addoperator' | translate }}
                </div>
              </a>
              <a class="w-full p-1" [routerLink]="'/main/operators'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/operators')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  {{ 'operatorList' | translate }}
                </div>
              </a>
              <a class="w-full p-1" [routerLink]="'/main/history-log'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/history-log')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  История заявок
                </div>
              </a>
            </div>
          </div>
          <div *ngIf="role !== 'operator'" class="panel-menu-section bg-blue-300">
            <div class="panel-menu-header cursor-pointer" (click)="toggleSection('reference')">
              <span>Справочники</span>
              <span class="arrow" [ngClass]="{'rotated': isSectionOpen('reference')}">&#9660;</span></div>
            <div class="panel-menu-content" *ngIf="isSectionOpen('reference')">
              <a class="w-full p-1" [routerLink]="'/main/edit-data'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/edit-data')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Справочники Вузов
                </div>
              </a>
              <a class="w-full p-1" [routerLink]="'/main/job-data'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/job-data')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Места Работ
                </div>
              </a>
            </div>
          </div>
          <div class="panel-menu-section bg-blue-300">
            <div class="panel-menu-header cursor-pointer" (click)="toggleSection('testing')">
              <span>Тестирование</span>
              <span class="arrow" [ngClass]="{'rotated': isSectionOpen('testing')}">&#9660;</span></div>
            <div class="panel-menu-content" *ngIf="isSectionOpen('testing')">
              <a class="w-full p-1" [routerLink]="'/main/stream-search'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/stream-search')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  {{ 'StreamSearch' | translate }}
                </div>
              </a>
              <a class="w-full p-1" *ngIf="role != 'operator'" [routerLink]="'/main/students'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/students')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  {{ 'SearchByStudent' | translate }}
                </div>
              </a>
              <a class="w-full p-1" [routerLink]="'/main/probtest'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/probtest')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Пробное тестирование
                </div>
              </a>
            </div>
          </div>
          <div *ngIf="role !== 'operator'" class="panel-menu-section bg-blue-300">
            <div class="panel-menu-header cursor-pointer" (click)="toggleSection('statistics')">
              <span>Статистика</span>
              <span class="arrow" [ngClass]="{'rotated': isSectionOpen('statistics')}">&#9660;</span></div>
            <div class="panel-menu-content" *ngIf="isSectionOpen('statistics')">
              <a class="w-full p-1" [routerLink]="'/main/stat-nqt'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/stat-nqt')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Статистика НКТ
                </div>
              </a>
            </div>
          </div>
          <div class="panel-menu-section bg-blue-300">
            <div class="panel-menu-header cursor-pointer" (click)="toggleSection('other')">
              <span>Прочее</span>
              <span class="arrow" [ngClass]="{'rotated': isSectionOpen('other')}">&#9660;</span></div>
            <div class="panel-menu-content" *ngIf="isSectionOpen('other')">
              <a class="w-full p-1" [routerLink]="'/main/incident'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/incident')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Инциденты
                </div>
              </a>
              <a class="w-full p-1" [routerLink]="'/main/back-pay'">
                <div [ngClass]="{'bg-blue-300': (router.url == '/main/back-pay')}"
                     class="panel-menu-item text-dark p-2 rounded text-base mt-1 cursor-pointer hover:bg-blue-300 hover:text-dark-900">
                  Возврат денежных средств
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
  <section class="w-full bClass p-4">
    <router-outlet></router-outlet>
  </section>
</main>
